import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject, OnInit} from '@angular/core';
import {IcDataService} from "../../services/ic-data.service";
import {firstValueFrom} from "rxjs";

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './save-digital-tags-dialog.component.html',
    styleUrls: ['./save-digital-tags-dialog.component.scss']
})

export class SaveDigitalTagsDialogComponent implements OnInit {
    completeProgress = 0;
    totalProcessCount = 0;
    currentProcessIndex = 0;
    statusMessage= '';
    hideStopStart= true;
    proccessingName= '';
    progressMode = 'determinate';
    processState = 'Processing';
    startStopMode = 'None';

    constructor(
        private dialogRef: MatDialogRef<SaveDigitalTagsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: SaveRecordsDialogModel,
        private icData: IcDataService,
    ) {

    }

    ngOnInit(): void {
        this.startProcessBatch(0);
    }

    startProcessBatch(startIndex: number): void {
        this.processBatchUpdate(this.data.records, startIndex).then( (processResult) => {
                if (processResult.result === 'Complete')
                {
                    this.processState = 'Results';
                }
                else {
                    this.processState = 'Error-Skip';
                    this.statusMessage = processResult.message;
                }
            }
        );
    }

    async processBatchUpdate(batchData: any[], startIndex = 0): Promise<any> {
        this.totalProcessCount = batchData.length;
        for (let _i = startIndex; _i < batchData.length; _i++) {
            this.hideStopStart = true;
            this.progressMode = 'determinate';
            const updateRecord = batchData[_i];
            this.completeProgress = Math.round((_i + 1) * 100 / batchData.length);
            this.currentProcessIndex = _i;
            this.proccessingName = updateRecord.title;
            try {
                await firstValueFrom(this.icData.createDigitalTag(updateRecord.title,updateRecord.color));
            } catch (error) {
                {
                    console.log(error);
                    const icStatusDescription = error.headers.get('icstatusdescription');
                    return {
                        result: 'Failed',
                        message: 'Failed to Process ' + error.error?.errors[0]?.message || error.error.error_description + ' - ' + icStatusDescription || ''
                    };
                }

            }
        }
        return {
            result: 'Complete',
            message: 'Update Complete',
            runningSkillError: false
        };
    }

    cancelProcess(): void {
        this.dialogRef.close(false);
    }

    skip(): void {
        this.startProcessBatch(this.currentProcessIndex + 1);
    }

    closeFinish() {
        this.dialogRef.close(true);
    }

}

export class SaveRecordsDialogModel {
    constructor(
        public records: any[]
    )
    {

    }
}


